import { render, staticRenderFns } from "./product-transaction-summary.vue?vue&type=template&id=2b2dad45&scoped=true&"
import script from "./product-transaction-summary.vue?vue&type=script&lang=js&"
export * from "./product-transaction-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2dad45",
  null
  
)

export default component.exports